export const formatDate = (timestamp: number): string => {
  if (timestamp < 0) {
    return ""
  }
  const dt = new Date(timestamp * 1000)
  return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt
    .getDate()
    .toString()
    .padStart(2, "0")}`
}
